<template>
  <div class="users-page container">
    <h1 class="title">
      Usuários
      <button
        disabled="disabled"
        class="button is-loading is-disabled is-white"
        style="background-color: #f5f5f5"
        v-if="isLoading"
      >
        ...
      </button>
    </h1>

    <div class="page-content">
      <data-table
        v-if="Users.items.length > 0"
        :data="Users.items"
        show-index
        striped
      >

        <table-toolbar>
          <template slot="left">
            <div class="level-item">
              <p class="control">
                <label class="label">Filtrar por papel</label>
                <span class="select">
                  <select v-model="role" @change="get">
                    <option disabled selected :value="null">Selecione</option>
                    <option v-for="(role, index) in roles" :key="index" :value="role">{{role}}</option>
                  </select>
                </span>
                <button class="button" :disabled="role === null" @click="role = null; get()">Limpar</button>
              </p>
            </div>
          </template>
          <template slot="right">
            <div class="level-item">
              <p class="control">
                <button class="button is-primary" @click="showAddModal = true">Criar Moderador</button>
              </p>
            </div>
          </template>
        </table-toolbar>

        <!-- <column label="Avatar">
          <template slot-scope="row">
            <figure class="image is-64x64">
              <img class="is-rounded" :src="row.avatarUrls ? row.avatarUrls['150x150'] : ''" :alt="`${row.firstName} ${row.lastName}`" />
            </figure>
          </template>
        </column> -->
        <column label="Nome" field="firstName" sorter="custom" />
        <column label="Sobrenome" field="lastName" />
        <column label="Email" field="email" />
        <column label="País" field="country" />
        <column label="Região" field="region" />
        <column label="Papel" field="role" />

        <column label="Ações" :width="160">
          <template slot-scope="row">
            <div class="control has-addons is-pulled-right">
              <button
                class="button is-primary is-small"
                @click="openPasswordModal(row)"
              >
                Trocar senha
              </button>
            </div>
          </template>
        </column>
      </data-table>
      <pagination
        :total="Users.total"
        :page-size="pageCtrl.limit"
        layout="pager"
        :change="get"
      />

    </div>
    <modal
      title="Adicionar Moderador"
      :width="600"
      :is-show="showAddModal"
      transition="fadeDown"
      cancel-text="Cancelar"
      :ok-loading="addLoading"
      ok-text="Criar moderador"
      @close="showAddModal=false;"
      :on-cancel="clearFields"
      :on-ok="create"
      :show-ok="!$v.fData.$invalid"
    >
        <label class="label">Nome:</label>
        <p class="control">
          <input class="input" type="text" v-model="fData.firstName">
        </p>

        <label class="label">Sobrenome:</label>
        <p class="control">
          <input class="input" type="text" v-model="fData.lastName">
        </p>

        <label class="label">Email:</label>
        <p class="control">
          <input class="input" type="email" v-model="fData.email">
        </p>

        <label class="label">Senha:</label>
        <p class="control">
          <input class="input" type="password" v-model="fData.password">
        </p>
    </modal>

    <modal
      :title="`Trocar senha de ${passwordUser.firstName || ''} ${passwordUser.lastName || ''}`"
      :width="500"
      :is-show="showPasswordModal"
      transition="fadeDown"
      cancel-text="Cancelar"
      :ok-loading="passwordLoading"
      ok-text="Alterar senha"
      @close="showPasswordModal=false;"
      :on-cancel="clearPasswordFields"
      :on-ok="changePassword"
      :show-ok="!$v.passwordForm.$invalid"
    >
        <p class="help is-info mb-10">
          Usuário: <strong>{{ passwordUser.email || '-' }}</strong>
        </p>

        <label class="label">Nova senha:</label>
        <p class="control">
          <input class="input" type="password" v-model="passwordForm.password">
        </p>

        <label class="label">Confirmar nova senha:</label>
        <p class="control">
          <input class="input" type="password" v-model="passwordForm.passwordConfirm">
        </p>

        <p v-if="passwordForm.password && passwordForm.passwordConfirm && passwordForm.password !== passwordForm.passwordConfirm"
           class="help is-danger">
          As senhas não coincidem.
        </p>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'UsersPage',
  data () {
    return {
      role: null,
      roles: ['moderator', 'admin', 'user'],
      isLoading: false,
      addLoading: false,
      showAddModal: false,
      fData: {
        firstName: null,
        lastName: null,
        email: null,
        password: null
      },
      pageCtrl: {
        limit: 100,
        skip: 0,
        page: 0
      },
      showPasswordModal: false,
      passwordLoading: false,
      passwordUser: {},
      passwordForm: {
        password: null,
        passwordConfirm: null
      }
    }
  },
  validations: {
    fData: {
      firstName: { required },
      lastName: { required },
      email: { required, email },
      password: { required, minLength: minLength(6) }
    },
    passwordForm: {
      password: { required, minLength: minLength(6) },
      passwordConfirm: {
        required,
        minLength: minLength(6),
        sameAsPassword: sameAs('password')
      }
    }
  },
  computed: {
    ...mapState({ Users: state => state.user.users })
  },
  methods: {
    ...mapActions(['getUsers', 'createModerator', 'adminChangePassword']),
    async get (page = 1) {
      try {
        this.isLoading = true
        await this.getUsers({ params: { ...this.pageCtrl, skip: this.pageCtrl.limit * (page - 1), role: this.role } })
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.isLoading = false
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível obter os Usuários.',
          duration: 10000
        })
      }
    },
    clearFields () {
      for (const key in this.fData) {
        this.fData[key] = null
      }
    },
    async create () {
      try {
        this.addLoading = true
        await this.createModerator(this.fData)
        this.addLoading = false
        this.$notify.open({
          type: 'success',
          content: 'Moderador criado com Sucesso!',
          duration: 10000
        })
        this.clearFields()
      } catch (error) {
        console.log(error)
        this.addLoading = false
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível criar o Moderador',
          duration: 10000
        })
        this.clearFields()
      }
    },
    openPasswordModal (row) {
      this.passwordUser = { id: row.id, firstName: row.firstName, lastName: row.lastName, email: row.email }
      this.passwordForm = { password: null, passwordConfirm: null }
      this.showPasswordModal = true
    },
    clearPasswordFields () {
      this.passwordForm = { password: null, passwordConfirm: null }
      this.passwordUser = {}
    },
    async changePassword () {
      try {
        if (this.passwordForm.password !== this.passwordForm.passwordConfirm) {
          this.$notify.open({
            type: 'danger',
            content: 'As senhas não coincidem.',
            duration: 8000
          })
          return
        }
        this.passwordLoading = true
        await this.adminChangePassword({
          userId: this.passwordUser.id,
          password: this.passwordForm.password
        })
        this.passwordLoading = false
        this.$notify.open({
          type: 'success',
          content: `Senha de ${this.passwordUser.email} alterada com sucesso!`,
          duration: 10000
        })
        this.showPasswordModal = false
        this.clearPasswordFields()
      } catch (error) {
        console.log(error)
        this.passwordLoading = false
        let message = 'Não foi possível alterar a senha.'
        if (error && error.response && error.response.data) {
          if (error.response.status === 403) {
            message = 'Acesso negado. Somente administradores podem alterar senhas.'
          } else if (error.response.status === 404) {
            message = 'Usuário não encontrado.'
          } else if (error.response.data && error.response.data.message) {
            message = error.response.data.message
          }
        }
        this.$notify.open({
          type: 'danger',
          content: message,
          duration: 12000
        })
      }
    }
  },
  async mounted () {
    await this.get()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/UsersPage.vue